module.exports = __webpack_public_path__ + "img/indexType_3.6309d32a.png";